module.exports = __webpack_public_path__ + "static/img/mcgraw2.0fd164f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/mcgraw2.jpg
// module id = fvu3
// module chunks = 1